import "../styles/Loader.css";
import { useTranslation } from "react-i18next";
const Loader = () => {
  const { t } = useTranslation();
  return (
    <div className="loader-container">
      <img
        src="/assets/logo192.png"
        alt={t("nav.logoName")}
        className="loader-logo"
      />
      <h1 className="loader-title">{t("nav.logoName")}</h1>
      <div className="loader-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loader;
